"use client";

import { useSession } from "next-auth/react";

import { useMe } from "@/features/account/hooks/use-me";
import { useUserflow } from "../common/layout/user-flow";

export function RouteChangeListener() {
  const session = useSession();
  const { data: customer } = useMe(session.data);

  useUserflow(customer);

  return null;
}
